export const state = {
    selectedTemplateType: '',
    templateTypeOptions: {
        productReviewAndSellerFeedback: {
            img: require('@/assets/images/amazon/amazon_review_request_example.png'),
            validations: {
                order_date: false,
                delivery_date: true,
                shipping_date: false,
                minDay: 5
            }
        }
    }
}

export const mutations = {
    SET_TEMPLATE_TYPE(state, type) {
        state.selectedTemplateType = type
    },
}


export const getters = {
    selectedTemplateType(state) {
        return state.selectedTemplateType
    },
    templateTypeOptions(state) {
        return state.templateTypeOptions
    },
    isOfficialType(state) {
        return state.selectedTemplateType === 'productReviewAndSellerFeedback'
    }
}


export const actions = {
    setTemplateType({commit}, {type}) {
        commit('SET_TEMPLATE_TYPE', type)
    },
}

